var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71371 0 0 6.71371 0 15C0 23.2863 6.71371 30 15 30C23.2863 30 30 23.2863 30 15C30 6.71371 23.2863 0 15 0ZM15 27.0968C8.31653 27.0968 2.90323 21.6835 2.90323 15C2.90323 8.31653 8.31653 2.90323 15 2.90323C21.6835 2.90323 27.0968 8.31653 27.0968 15C27.0968 21.6835 21.6835 27.0968 15 27.0968ZM21.1573 11.2379L17.3952 15L21.1573 18.7621C21.4415 19.0464 21.4415 19.506 21.1573 19.7903L19.7903 21.1573C19.506 21.4415 19.0464 21.4415 18.7621 21.1573L15 17.3952L11.2379 21.1573C10.9536 21.4415 10.494 21.4415 10.2097 21.1573L8.84274 19.7903C8.55847 19.506 8.55847 19.0464 8.84274 18.7621L12.6048 15L8.84274 11.2379C8.55847 10.9536 8.55847 10.494 8.84274 10.2097L10.2097 8.84274C10.494 8.55847 10.9536 8.55847 11.2379 8.84274L15 12.6048L18.7621 8.84274C19.0464 8.55847 19.506 8.55847 19.7903 8.84274L21.1573 10.2097C21.4415 10.494 21.4415 10.9536 21.1573 11.2379Z",
    fill: "#F27FCB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.8a8fe0f7f8599f3dd392ada27944bfd0.svg";
export { ForwardRef as ReactComponent };